import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
    reduxForm,
    Field,
    change,
    formValueSelector,
    getFormSyncErrors,
} from "redux-form";
import {
    checkout,
    buildCheckoutSale,
    storeCheckoutSale,
    cancelExternalRedirect,
    createStripeCardToken,
} from "../actions/checkoutActions";
import {
    createOpenpayOrder,
    resetOpenpayPlan,
} from "../actions/openpayActions";
import { checkSession } from "../actions/accountActions";
import { clearOrder } from "../actions/orderActions";
import FormField from "../components/FormField";
import ConfirmDialog from "../components/ConfirmDialog";
import Cart from "./Cart";
import { Redirect } from "react-router-dom";
import { showSuccess, showError } from "../common/iziToast";
import * as Icons from "../common/icons";
import OrderSummary from "./OrderSummary";
import { required, length, numericality } from "redux-form-validators";
import { cardExpiry } from "../common/validators";
import PaymentInfo from "../components/PaymentInfo";
import ShippingInfo from "../components/ShippingInfo";
import { utils } from "../common/utils";
import { withRouter } from "react-router";
import { CheckoutWizardSteps, PaymentMethodEnum } from "../common/enums";
import Cards from "react-credit-cards";
import "react-credit-cards/es/styles-compiled.css";
import { withTranslation } from "react-i18next";
import {
    formatCreditCardNumber,
    formatCVC,
    formatExpirationDate,
} from "../common/cardUtils";
import GoogleAddressAutoComplete from "../components/GoogleAddressAutoComplete";
import ExtendedLink from "../components/ExtendedLink";
import Alert from "../components/Alert";
import ExternalRedirectPayment from "../components/ExternalRedirectPayment";
import ExternalRedirectPaymentFailed from "../components/ExternalRedirectPaymentFailed";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEnvelope,
    faCircleCheck,
    faCircleXmark,
    faFileInvoice
} from "@fortawesome/free-solid-svg-icons";
import { Elements, PaymentElement, useStripe, useElements,CardElement , CardNumberElement, CardCvcElement, CardExpiryElement
} from '@stripe/react-stripe-js';
import {removeFromCart} from '../actions/cartActions';
import { isPromoLine, cartLineKey } from '../common/cartUtils';


//https://github.com/amarofashion/react-credit-cards
class CheckoutForm extends Component {
    state = {
        activeStep: 1,
        paymentCardType: "",
        stepHasError: false,
        focused: "",
        name: "",
        isSubmitDisabled: false,
        disableAddressFields: false,
        showExternalRedirectConfirmation: false,
        hasErrorPayingWithExternalPayment: false,
        visibleWindow: false,
        isKlarnaWindowOpen: false,
        isMobilePayWindowOpen: false,
        isUserCancelledKlarna: false,
        isUserCancelledMobilePay: false,
        isInvalidCart: false,
        discountCodeError: "",
        isDiscountCodeApplied: false,
        paymentMethod: PaymentMethodEnum.Card,
        cardToken: "", cardExpiryMonth: "", cardExpiryYear: "", cardNumberLastFour: "",
        mobileNumber: '', isDiscountCodeApplied: false,
        cardElementValidation: {
            cardNumberError: "",
            cardExpiryError: "",
            cardCVCError: "",
        },
        cardElementGeneralError: "",
        timerObject: null
    };

    handleInputFocus = (e) => {
        this.setState({ focused: e.target.name });
    };

    handleWizardNext = async () => {
        let isCardTokenValid = await this.createCardToken()
        if (this.isValid() && isCardTokenValid) {
            this.setState({ activeStep: this.state.activeStep + 1 });
            if (this.state.activeStep === CheckoutWizardSteps.Payment) {
                const { settings, cart } = this.props;
                if (window.fbq) {
                    window.fbq("track", "AddPaymentInfo");
                }

                if (window.vgo) {
                    window.vgo("update");
                    window.vgo("process");
                }

                if (window.gtag) {
                    let totalQuantityPrice = cart.lines.reduce(function(
                        accumulator,
                        currentLine
                    ) {
                        return (
                            accumulator +
                            currentLine.quantity * (currentLine.isLoyaltyPointsUsed ? 0 : currentLine.product.specialPrice)
                        );
                    },
                        0);

                    window.gtag("event", "add_payment_info", {
                        currency: settings.isoCurrencySymbol,
                        items: cart.lines.map((line) => ({
                            item_id: line.product.stockItemCode,
                            item_name: line.product.title,
                            item_category: line.product.groupName,
                            price: line.product.specialPrice,
                            currency: settings.isoCurrencySymbol,
                            quantity: line.quantity,
                        })),
                        payment_type: this.state.paymentCardType,
                        payment_method: this.state.paymentMethod,
                        value: totalQuantityPrice
                    });
                }
            }
            utils.scrollTop();
        }

    };

    handleWizardPrev = () => {
        this.setState({ activeStep: this.state.activeStep - 1 });

        utils.scrollTop();
    };

    handleWizardTabClick = async (tabNumber) => {
        const isCardTokenValid = await this.createCardToken();
        if (this.isValid() && isCardTokenValid) {
            this.setState({ activeStep: tabNumber });
            utils.scrollTop();
        }
    };

    isValid = () => {
        const { shipping, payment, touch, errors } = this.props;
        const { activeStep } = this.state;
        if (this.state.isUserCancelledKlarna === true) {
            this.setState({ isUserCancelledKlarna: false });
            this.props.clearOrder();
        }

        if (this.state.isUserCancelledMobilePay === true) {
            this.setState({ isUserCancelledMobilePay: false });
            this.props.clearOrder();
        }

        if (
            activeStep === CheckoutWizardSteps.ShippingAddress &&
            Object.keys(shipping).some((key) =>
                Object.keys(errors).includes(key)
            )
        ) {
            touch(...Object.keys(shipping));
            return false;
        } else if (
            activeStep === CheckoutWizardSteps.Payment &&
            Object.keys(payment).some((key) =>
                Object.keys(errors).includes(key)
            )
        ) {
            touch(...Object.keys(payment));
            return false;
        }

        return true;
    };

    handleCardChange = (type, isValid) => {
        this.setState({ paymentCardType: type.issuer });
    };

    getSaleData = () => {
        const { user, t } = this.props;
        // const {paymentMethod} = this.state;
        const {
            cart,
            shipping,
            payment,
            discountCode,
            settings,
            checkoutSale,
        } = this.props;
        var invalidCartLines = cart.lines
            .filter((line) => {
                return line.stockItemId === undefined || line.stockItemId === 0;
            })
            .map((line) => line.product.title);

        if (invalidCartLines && invalidCartLines.length > 0) {
            showError(
                t("Invalid Cart"),
                `${utils.formatString(
                    t("InvalidCartProducts"),
                    invalidCartLines.join(", ")
                )}`,
                Icons.CART
            );
            this.setState({ isInvalidCart: true });
            return null;
        } else {
            this.setState({ isInvalidCart: false });
        }

    const itemDetails = checkoutSale?.itemDetails ?? [];

    // Remove promo lines not present in checkoutSale
    const filteredCartLines = cart.lines.filter(line => {
        const isPromoAndNotInItemDetails =
            isPromoLine(line.isPromo) &&
            !itemDetails.some(
                item => item.stockItemId === line.stockItemId && isPromoLine(item.isPromotion)
            );

        if (isPromoAndNotInItemDetails) {
            this.props.dispatch(removeFromCart({ stockItemId: line.stockItemId, isPromo: line.isPromo }));
            return false;
        }
        return true;
    });

    //  Build a Map with key = stockItemId + isPromo
    const cartMap = new Map(
        filteredCartLines.map(line => [cartLineKey(line.stockItemId, line.isPromo), line.quantity])
    );

    // Updated existing items
    const updatedExistingItems = itemDetails
        .map(item => {
            // Find all matching cart lines for this stockItemId and promo status
            const matchingLines = filteredCartLines.filter(
                line => line.stockItemId === item.stockItemId && isPromoLine(line.isPromo) === isPromoLine(item.isPromotion)
            );

            return matchingLines.map(line => ({
                ...item,
                quantity: cartMap.get(cartLineKey(line.stockItemId, line.isPromo)),
                isPromo: isPromoLine(line.isPromo),
                isLoyaltyPointsUsed: line.isLoyaltyPointsUsed === true
            }));
        })
        .flat();

    //  New items not in checkoutSale yet
    const existingItemKeys = new Set(
    itemDetails.map(i => cartLineKey(i.stockItemId, i.isPromotion))
);

const newItems = filteredCartLines
    .filter(line => !existingItemKeys.has(cartLineKey(line.stockItemId, line.isPromo)))
    .map(line => ({
        stockItemId: line.stockItemId,
        quantity: line.quantity,
        isPromo: isPromoLine(line.isPromo),
        isLoyaltyPointsUsed: line.isLoyaltyPointsUsed === true
    }));

    //  Merge all items
    const mergedItemDetails = [...updatedExistingItems, ...newItems];

        const saleTotal = checkoutSale
            ? checkoutSale.saleTotalAfterDiscount
            : 0;
        const saleTotalAsInt = checkoutSale
            ? checkoutSale.saleTotalAfterDiscountAsInt
            : 0;
        const sale = {
            customerId: user.id,
            stockItems: mergedItemDetails,
            customerTypeId: 2,
            totalPaid: saleTotal,
            totalPaidAsInt: saleTotalAsInt,
            paymentMethod: this.state.paymentMethod,
            cardNumber: settings.isStripeElementsFeatureEnabled ? this.state.cardNumberLastFour : payment.number,
            amount: saleTotal,
            cvc: payment.cvc,
            expiryMonth: settings.isStripeElementsFeatureEnabled ? this.state.cardExpiryMonth : payment.expiry.substring(0, 2),
            expiryYear: settings.isStripeElementsFeatureEnabled ? this.state.cardExpiryYear : payment.expiry.substring(3, payment.expiry.length),
            paymentCardType: this.state.paymentCardType,
            paymentEmail: payment.email,
            discountCode: discountCode,
            address1: shipping.address1,
            address2: shipping.address2,
            address3: shipping.address3,
            address4: shipping.address4,
            postCode: shipping.postCode,
            regionId: shipping.regionId,
            regionName: shipping.regionName,
            titleId: shipping.titleId,
            firstName: shipping.firstName,
            lastName: shipping.lastName,
            organization: shipping.organization,
            deliveryServiceId: settings.deliveryServiceId,
            paymentCardtoken: this.state.cardToken,
        };
        return sale;
    };

    cancelExternalRedirection = ($this) => {
        $this.setState({
            isSubmitDisabled: false,
            showExternalRedirectConfirmation: false,
        });
    };

    onExternalRedirectPaymentFails = ($this) => {
        $this.setState({ isSubmitDisabled: false, activeStep: 1 });
    };

    onExternalPaymentComplete = ($this) => {
        if(this.state.timerObject) {
            clearInterval(this.state.timerObject)
        }
        $this.setState({ isKlarnaWindowOpen: false, isMobilePayWindowOpen: false, timerObject: null});
    };
    redirectToOpenpay = ($this, sale) => {
        return $this.props.createOpenpayOrder(sale).then(
            (response) => {
                if (response && response.value) {
                    const resultResponse = response.value.data;
                    if (resultResponse && resultResponse.isSuccess === true) {
                        const openpayResponse = resultResponse.openpayResponse;
                        //store openpay response
                        sale.openpayTransactionToken =
                            resultResponse.openpayTransactionToken;
                        sale.openpayOrderId = openpayResponse.orderId;
                        $this.props.storeCheckoutSale(sale);
                        // redirect to openpay gateway
                        window.location.href = `${openpayResponse.nextAction.formPost.formPostUrl}?TransactionToken=${resultResponse.openpayTransactionToken}`;
                    }
                } else {
                    this.setState({ hasErrorPayingWithExternalPayment: true });
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };

    redirectToKlarna = ($this, sale) => {
        const { klarnaLoadingUrl } = this.props.settings;
        const { innerWidth, innerHeight } = window;
        const popUpWidth = 550,
            popUpHeight = 750;
        const left = innerWidth / 2 - popUpWidth / 2;
        const top = innerHeight / 2 - popUpHeight / 2;
        $this.setState({ isKlarnaWindowOpen: true });
        var win = window.open(
            klarnaLoadingUrl,
            "Klarna",
            `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no,width=${popUpWidth},height=${popUpHeight}, top=${top}, left=${left}`
        );
        var timer = setInterval(function () {
            if (win.closed && $this.state.isKlarnaWindowOpen === true) {
                clearInterval(timer);
                $this.setState({
                    isKlarnaWindowOpen: false,
                    isUserCancelledKlarna: true,
                });
                $this.props.cancelExternalRedirect();
                $this.onExternalRedirectPaymentFails($this);
            }
        }, 1000);

        return $this.props.checkout(sale).then(
            (response) => {
                $this.handleKlarnaPaymentResponse(response, win);
            },
            (error) => {
                console.log(error);
            }
        );
    };
    redirectToMobilePay = ($this, sale) => {
        const { mobilePayLoadingUrl } = this.props.settings;
        const { innerWidth, innerHeight } = window;
        const popUpWidth = 550,
            popUpHeight = 750;
        const left = innerWidth / 2 - popUpWidth / 2;
        const top = innerHeight / 2 - popUpHeight / 2;
        $this.setState({ isMobilePayWindowOpen: true });
        var win = window.open(
            mobilePayLoadingUrl,
            "MobilePay",
            `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no,width=${popUpWidth},height=${popUpHeight}, top=${top}, left=${left}`
        );

        var timer = setInterval(function() {
            if (win.closed && $this.state.isMobilePayWindowOpen === true) {
                clearInterval(timer);
                $this.setState({
                    isMobilePayWindowOpen: false,
                    isUserCancelledMobilePay: true,
                });
                $this.props.cancelExternalRedirect();
                $this.onExternalRedirectPaymentFails($this);
            }
        }, 1000);
        this.setState({ timerObject: timer});

        return $this.props.checkout(sale).then(
            (response) => {

                $this.handleMobilePayPaymentResponse(response, win);
            },
            (error) => {
                console.log(error)
            }
        );
    };
    handleKlarnaPaymentResponse = (response, win) => {
        if (response && response.value) {
            const resultResponse = response.value.data;
            if (
                resultResponse &&
                resultResponse.isSuccess === true &&
                resultResponse.requiresActionExternalRedirect === true
            ) {
                win.location = resultResponse.paymentProviderRedirectURL;
            }
        } else {
            win.close();
            this.setState({ hasErrorPayingWithExternalPayment: true });
        }
    };
    handleMobilePayPaymentResponse = (response, win) => {
        if (response && response.value) {
            const resultResponse = response.value.data;
            if (
                resultResponse &&
                resultResponse.isSuccess === true &&
                resultResponse.requiresActionExternalRedirect === true
            ) {
                win.location = resultResponse.paymentProviderRedirectURL;
            }
        } else {
            win.close();
            this.setState({ hasErrorPayingWithExternalPayment: true });
        }
    };
    //};

    redirectToExternalPaymentGateway = ($this) => {
        const { paymentMethod} = $this.state;
        const sale = $this.getSaleData();
        if (sale === null) return;
        $this.setState({
            isSubmitDisabled: true,
            showExternalRedirectConfirmation: false,
        });
        if (paymentMethod === PaymentMethodEnum.OpenPay) {
            this.redirectToOpenpay($this, sale);
        } else if (paymentMethod === PaymentMethodEnum.Klarna) {
            this.redirectToKlarna($this, sale);
        }
        else if (paymentMethod === PaymentMethodEnum.MobilePay) {
            this.redirectToMobilePay($this, sale);
        }
    };

    handleAgreeToTerms = (e) => {
        this.setState({
            isSubmitDisabled: e.target.checked !== true,
        });
    };

    handleSubmitOrder = (data) => {
        const { user, settings } = this.props;
        if (!user.isAuthenticated) {
            return false;
        }

        const { paymentMethod} = this.state;
        if (paymentMethod === PaymentMethodEnum.OpenPay ||
            paymentMethod === PaymentMethodEnum.Klarna ||
            paymentMethod === PaymentMethodEnum.MobilePay) {

            this.setState({ showExternalRedirectConfirmation: true });
        } else {
            const sale = this.getSaleData();
            if (sale === null) return;

            if (paymentMethod === PaymentMethodEnum.Card &&
                settings.isStripeElementsFeatureEnabled && this.state.cardToken === "") return

            this.setState({ isSubmitDisabled: true });


            return this.props.checkout(sale).then((response) => {
            }, (error) => {
                console.log(error)
            });
        }
    };

    handleApplyDiscountCode = (data) => {
        const { user } = this.props;
        if (!user.isAuthenticated) {
            return false;
        }
        this.recalculateOrder();
    };

    handleRemoveDiscountCode = () => {
        const { change, user, t } = this.props;
        if (user.isAuthenticated) {
            const sale = this.getSaleData();
            if (sale === null) return;
            sale.discountCode = "";
            this.props.buildCheckoutSale(sale).then((response) => {
                this.fireMarketingEvents();
                if (
                    response.action?.payload?.data?.sale?.itemDiscountCodes
                        ?.length === 0
                ) {
                    // clear form
                    this.props.dispatch(change("checkout", "discountCode", ""));

                    // Clear applied status and then after updating state recalculate sale
                    this.setState(
                        { isDiscountCodeApplied: false, discountCodeError: "" },
                        showSuccess(
                            t("Discount Code"),
                            t(
                                `Successfully removed your discount code from your order!`
                            )
                        )
                    );
                }
            });
            // // clear form
            // this.props.dispatch(change('checkout', "discountCode", ""))

            // // Clear applied status and then after updating state recalculate sale
            // this.setState({ isDiscountCodeApplied: false, discountCodeError: "" }, this.recalculateOrder)
        }
    };

    recalculateOrder = () => {
        const { user, touch, discountCode, t } = this.props;
        if (user.isAuthenticated) {
            const sale = this.getSaleData();
            if (sale === null) return;
            this.props.buildCheckoutSale(sale).then(
                (response) => {
                    const data = response?.action?.payload?.data;
                    this.fireMarketingEvents();
                    // sale discount code is invalid
                    if (data?.validationResult?.hasError === true) {
                        this.setState({
                            discountCodeError: data.validationResult.errorText,
                        });
                    }
                    // sale discount code valid && have been applied.
                    else if (
                        data?.sale?.itemDiscountCodes.length > 0 &&
                        data?.validationResult?.hasError === false
                    ) {
                        this.setState({ isDiscountCodeApplied: true, discountCodeError: "" });
                        showSuccess(
                            t("Discount Code"),
                            t(
                                `Successfully added your discount code to your order!`
                            )
                        );
                    } else if (data?.validationResult?.hasError === false) {
                        this.setState({
                            discountCodeError: "",
                        });
                        if (this.props.untouch) {
                            this.props.untouch("discountCode");
                        }
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    // validateDiscountCode = (value, allValued, props) => {
    //     console.log("inside discount code validation")
    //     if (this.state.discountCodeError) {
    //         return this.state.discountCodeError;
    //     }
    //     return null;
    // }

    fireMarketingEvents = () => {
        const { settings, cart } = this.props;
        if (window.fbq) {
            var fbqContentsList = cart.lines.map((line) => ({
                id: line.product.stockItemCode,
                quantity: line.quantity,
            }));
            window.fbq("track", "InitiateCheckout", {
                currency: settings.isoCurrencySymbol,
                value: "0.00",
                num_items: cart.length,
                content_type: "product",
                contents: fbqContentsList,
            });
        }
        if (window.vgo) {
            window.vgo("update");
            window.vgo("process");
        }

        if (window.gtag) {
            let totalQuantityPrice = cart.lines.reduce(function(
                accumulator,
                currentLine
            ) {
                return (
                    accumulator + currentLine.quantity * (currentLine.isLoyaltyPointsUsed ? 0 : currentLine.product.specialPrice)
                );
            },
                0);

            window.gtag("event", "begin_checkout", {
                currency: settings.isoCurrencySymbol,
                items: cart.lines.map((line) => ({
                    item_id: line.product.stockItemCode,
                    item_name: line.product.title,
                    item_category: line.product.groupName,
                    price: line.product.specialPrice,
                    currency: settings.isoCurrencySymbol,
                    quantity: line.quantity,
                })),
                value: totalQuantityPrice,
            });
        }
    };

    onRegionChange = (e) => {
        //console.log(e.target);
        const { shipping } = this.props;
        const selectElem = e.target;
        shipping.regionId = selectElem.value;
        shipping.regionName = selectElem.options[selectElem.selectedIndex].text;
        this.recalculateOrder();
    };

    componentDidMount() {
        const { user, settings } = this.props;
        if (user.isAuthenticated) {
            this.props.resetOpenpayPlan();
            this.recalculateOrder();
            if (settings && settings.showTermsOnCheckout === true) {
                this.setState({ isSubmitDisabled: true });
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            orderSubmitError,
            cart,
            asyncValidate,
            checkoutSale,
        } = this.props;

        const { cardElementValidation, cardElementGeneralError } = this.state;

        if(Object.entries(cardElementValidation).some(([key, value]) => {


            if(cardElementGeneralError !== "" && value === cardElementGeneralError) return true
            else return false;

        }))
            (
                this.setState({ cardElementGeneralError: "" })
            )

        if (
            orderSubmitError &&
            orderSubmitError.id != null &&
            prevProps.orderSubmitError.id !== orderSubmitError.id &&
            orderSubmitError.moduleCode === 10
        ) {
            // payment error
            this.setState({ isSubmitDisabled: false });
        }

        if (prevProps.cart.length != cart.length) {
            this.recalculateOrder();
        }
        // if the validation result updated from server, update the client
        if (
            checkoutSale &&
            checkoutSale.validationResult &&
            checkoutSale.validationResult.errorText != "No error" &&
            checkoutSale.validationResult.errorText !==
            prevProps.checkoutSale.validationResult.errorText
        )
            asyncValidate();
    }

    onGoogleAddressChange(mappedAddress) {
        this.props.change("checkout", "address1", mappedAddress.address1);
        this.props.change("checkout", "address2", mappedAddress.address2);
        this.props.change("checkout", "address3", mappedAddress.address3);
        this.props.change("checkout", "address4", mappedAddress.address4);
        this.props.change("checkout", "postCode", mappedAddress.postCode);
        this.setState({ disableAddressFields: false });
    }

    payByOpenpayHanlder() {
        utils.scrollTop();
        this.setState({ paymentMethod: PaymentMethodEnum.OpenPay });
    }

    payByKlarnaHanlder() {
        utils.scrollTop();
        this.setState({ paymentMethod: PaymentMethodEnum.Klarna });
    }

    payByMobilePayHanlder() {
        utils.scrollTop();
        this.setState({paymentMethod: PaymentMethodEnum.MobilePay });
    }
    payByCardHanlder() {
        this.setState({ paymentMethod: PaymentMethodEnum.Card });
    }

    payByInvoiceHandler() {
        utils.scrollTop();
        this.setState({ paymentMethod: PaymentMethodEnum.BankTransfer });
    }

    async createCardToken() {
        const { settings, elements, stripe } = this.props;
        const { paymentMethod, cardElementValidation } = this.state;
        let returnFlag = false;

        if (paymentMethod === PaymentMethodEnum.Card &&
            this.state.activeStep === CheckoutWizardSteps.Payment && settings.isStripeElementsFeatureEnabled) {

            if (Object.entries(cardElementValidation).some(([key, value]) => value !== "")) return false;
            const cardElement = elements.getElement(CardNumberElement)
            const resp = await this.props.createStripeCardToken(stripe, cardElement);

            const token = resp.value.token

            if (token) {

                returnFlag = true;
                this.setState({
                    cardToken: token.id,
                    paymentCardType: token.card.brand.toLowerCase(),
                    cardExpiryMonth: token.card.exp_month,
                    cardExpiryYear: token.card.exp_year,
                    cardNumberLastFour: token.card.last4,
                    cardElementGeneralError: ""

                });

            }
            else if (resp.value.error && resp.value.error.message) {

                // if(Object.entries(cardElementValidation).some(([key, value]) => value === resp.value.error.message)) {
                this.setState({ cardElementGeneralError: resp.value.error.message })

                returnFlag = false;
            }
            else returnFlag = false;
        }
        else {
            return true;
        }
        return returnFlag;
    }

    getBackButton() {
        const { t, settings } = this.props;
        const { activeStep } = this.state;
        const backButton =
            activeStep === CheckoutWizardSteps.ShippingAddress ? (
                <ExtendedLink
                    to={`${settings.baseUrl}cart`}
                    className="btn btn-outline-secondary"
                >
                    <i className="icon-arrow-left" />
                    <span className="hidden-xs-down">
                        &nbsp;{t("Back To Cart")}
                    </span>
                </ExtendedLink>
            ) : (
                <a
                    href={null}
                    role="button"
                    className="btn btn-outline-secondary"
                    onClick={this.handleWizardPrev}
                >
                    <i className="icon-arrow-left" />
                    <span className="hidden-xs-down">&nbsp;{t("Back")}</span>
                </a>
            );

        return backButton;
    }

    getNextButton() {
        const {
            activeStep,
            isSubmitDisabled,
            paymentMethod
        } = this.state;
        const { t, settings } = this.props;
        const nextButton =
            activeStep < CheckoutWizardSteps.Review ? (
                <a
                    href={null}
                    role="button"
                    className="btn btn-primary"
                    onClick={this.handleWizardNext}
                >
                    <span className="hidden-xs-down">
                        {t("Continue")}&nbsp;
                    </span>
                    <i className="icon-arrow-right" />
                </a>
            ) : (
                <Fragment>
                    {paymentMethod == PaymentMethodEnum.OpenPay && (
                        <img
                            src="img/TrustSeal_Amber 2x.png"
                            className="openpay-logo"
                        />
                    )}
                    {paymentMethod == PaymentMethodEnum.Klarna && (
                        <img
                            src="img/Klarna/Klarna-logo.svg"
                            className="mr-2"
                        />
                    )}
                    <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmitDisabled}
                    >
                        {/* <span className="hidden-xs-down"> */}
                        <span > 
                            {t("Complete Order")}&nbsp;
                        </span>
                        <i className="icon-arrow-right" />
                    </button>
                </Fragment>
            );
        return nextButton;
    }

    getRegionSelect() {
        const { user, settings, t } = this.props;

        const regionSelection = user.isNativeCustomer ? (
            <Fragment>
                <Field
                    name="regionName"
                    component={FormField}
                    disabled={true}
                    type="text"
                    defaultValue={user.regionName}
                ></Field>
                <Field
                    name="regionId"
                    component={FormField}
                    type="hidden"
                ></Field>
            </Fragment>
        ) : (
            <Field
                name="regionId"
                component={FormField}
                className="form-control"
                onChange={this.onRegionChange.bind(this)}
                validate={[required({ msg: t("is required") })]}
            >
                <option value="">{t("Select a region")}</option>
                {settings.deliveryRegions &&
                    settings.deliveryRegions.map((option) => (
                        <option value={option.id} key={option.id}>
                            {option.name}
                        </option>
                    ))}
            </Field>
        );

        return regionSelection;
    }

    handleCheckoutConfirmationsAndAlerts() {
        const { t, user, settings, cart, orderResponse } = this.props;
        const { klarnaLoadingUrl, mobilePayLoadingUrl } = settings;
        const {
            paymentMethod,
            isKlarnaWindowOpen,
            isUserCancelledKlarna,
            isMobilePayWindowOpen,
            isUserCancelledMobilePay,
            isInvalidCart
        } = this.state;
        let confirmResult = {
            shouldReturn: false,
            returnResult: null,
            overlayResult: null,
        };
        if (!user.isAuthenticated) {
            confirmResult.returnResult = (
                <ConfirmDialog
                    open={true}
                    title={t("Checkout")}
                    message={t("You must login before checkout.")}
                    yesTitle={t("Login/Register")}
                    onYes={() =>
                        this.props.history.push(`${settings.baseUrl}login`)
                    }
                    noTitle={t("Go Back")}
                    onNo={() => this.props.history.go(-2)}
                />
            );
        } else if (isInvalidCart === true) {
            confirmResult.returnResult = (
                <Redirect to={`${settings.baseUrl}cart`} />
            );
        } else if (this.state.hasErrorPayingWithExternalPayment === true) {
            let gatewayName = "";
            if (paymentMethod === PaymentMethodEnum.OpenPay) {
                gatewayName = t("Openpay");
            } else if (paymentMethod === PaymentMethodEnum.Klarna) {
                gatewayName = t("Klarna");
            } else if (paymentMethod === PaymentMethodEnum.MobilePay) {
                gatewayName = t("MobilePay");
            }
            confirmResult.returnResult = (
                <Alert
                    type="danger"
                    title={t("Checkout")}
                    msg={t(
                        `Unable to process your payment using ${gatewayName}. please try again later`
                    )}
                />
            );
        } else if (
            (orderResponse.requiresActionExternalRedirect === true || isKlarnaWindowOpen || isMobilePayWindowOpen) && isUserCancelledKlarna !== true && isUserCancelledMobilePay !== true) {
            confirmResult.returnResult = (
                <ExternalRedirectPayment
                    orderResponse={orderResponse}
                    payByKlarna={paymentMethod === PaymentMethodEnum.Klarna}
                    isKlarnaWindowOpen={isKlarnaWindowOpen}
                    klarnaLoadingUrl={klarnaLoadingUrl}
                    payByMobilePay={paymentMethod === PaymentMethodEnum.MobilePay}
                    isMobilePayWindowOpen={isMobilePayWindowOpen}
                    mobilePayLoadingUrl={mobilePayLoadingUrl}
                    onPaymentComplete={() =>
                        this.onExternalPaymentComplete(this)
                    }
                />
            );
        }
        // else if (

        //     (orderResponse.requiresActionExternalRedirect === true ||
        //         isMobilePayWindowOpen) &&
        //     isUserCancelledMobilePay !== true && !isKlarnaWindowOpen
        // ) {
        //     confirmResult.returnResult = (
        //         <ExternalRedirectPayment
        //             orderResponse={orderResponse}
        //             payByKlarna={paymentMethod === PaymentMethodEnum.Klarna}
        //             isKlarnaWindowOpen={isKlarnaWindowOpen}
        //             klarnaLoadingUrl={klarnaLoadingUrl}
        //             payByMobilePay={paymentMethod === PaymentMethodEnum.MobilePay}
        //             isMobilePayWindowOpen={isMobilePayWindowOpen}
        //             mobilePayLoadingUrl={mobilePayLoadingUrl}
        //             onPaymentComplete={() =>
        //                 this.onExternalPaymentComplete(this)
        //             }
        //         />
        //     );


        // }
        else if (orderResponse.failedExternalRedirectSVerification === true) {
            confirmResult.returnResult = (
                <ExternalRedirectPaymentFailed
                    orderResponse={orderResponse}
                    payByKlarna={paymentMethod === PaymentMethodEnum.Klarna}
                    payByMobilePay={paymentMethod === PaymentMethodEnum.MobilePay}
                    onClose={() => this.onExternalRedirectPaymentFails(this)}
                />
            );
        } else if (
            orderResponse.newOrderId > 0 &&
            orderResponse.requiresActionExternalRedirect !== true
        ) {
            showSuccess(
                t("Checkout"),
                t("Your order has been submitted"),
                Icons.CART
            );
            confirmResult.returnResult = (
                <Redirect to={`${settings.baseUrl}checkout-complete`} />
            );
        } else if (!cart || cart.lines.length === 0) {
            confirmResult.returnResult = (
                <ConfirmDialog
                    title="Checkout"
                    open={true}
                    message={t(
                        "You need to add some products to the cart before checkout."
                    )}
                    yesTitle={t("Continue Shopping")}
                    onYes={() =>
                        this.props.history.push(`${settings.baseUrl}categories`)
                    }
                    onNo={() => this.props.history.go(-2)}
                />
            );
        } else if (this.state.showExternalRedirectConfirmation === true) {
            let message = "",
                yesTitle = "";
            if (paymentMethod === PaymentMethodEnum.OpenPay) {
                message = t(
                    "You will be redirected to openpay to complete your payment."
                );
                yesTitle = t("GoToOpenpay");
            } else if (paymentMethod === PaymentMethodEnum.Klarna) {
                message = t(
                    "You will be redirected to Klarna to complete your payment."
                );
                yesTitle = t("GoToKlarna");
            }
            else if (paymentMethod === PaymentMethodEnum.MobilePay) {
                message = t("You will be redirected to MobilePay to complete your payment.");
                yesTitle = t("GoToMobilePay");
            }

            confirmResult.overlayConfirmResult = (
                <ConfirmDialog
                    open={true}
                    title={t("Checkout")}
                    message={message}
                    yesTitle={yesTitle}
                    onYes={() => this.redirectToExternalPaymentGateway(this)}
                    noTitle={t("Go Back")}
                    onNo={() => this.cancelExternalRedirection(this)}
                />
            );
        }

        confirmResult.shouldReturn = confirmResult.returnResult !== null;

        return confirmResult;
    }

    handleCardElementsValidation(e, elementName) {
        this.setState(prevState => {
            let cardElementValidation = {
                ...prevState.cardElementValidation
            }
            cardElementValidation[elementName + "Error"] = (e.error && e.error.message) ? e.error.message : "";
            return { cardElementValidation }
        })
    }

    isDarkModeEnabled() {
        if (typeof document === "undefined") return false;

        const bodyHasDarkMode = document.body && document.body.classList.contains("dark-mode");
        const htmlHasDarkMode = document.documentElement && document.documentElement.classList.contains("dark-mode");

        return bodyHasDarkMode || htmlHasDarkMode;
    }

    getThemeVariable(variableName, fallbackColor) {
        if (typeof window === "undefined" || typeof document === "undefined" || !window.getComputedStyle || !document.body) {
            return fallbackColor;
        }

        const value = window.getComputedStyle(document.body).getPropertyValue(variableName);
        return value && value.trim() ? value.trim() : fallbackColor;
    }

    getStripeElementOptions(includeInvalidStyle = false) {
        const isDarkMode = this.isDarkModeEnabled();
        const baseTextColor = this.getThemeVariable("--theme-text-primary", isDarkMode ? "#e6edf3" : "#212529");
        const placeholderColor = this.getThemeVariable("--theme-text-secondary", "#9DA9B9");

        const style = {
            base: {
                color: baseTextColor,
                fontFamily: "Maven Pro, Helvetica, Arial, sans-serif",
                fontSize: "14px",
                ":-webkit-autofill": {
                    color: baseTextColor,
                },
                "::placeholder": {
                    color: placeholderColor,
                    fontFamily: "Maven Pro, Helvetica, Arial, sans-serif",
                    fontSize: "14px",
                },
                lineHeight: "40px",
            },
        };

        if (includeInvalidStyle) {
            style.invalid = {
                color: "#ff5252",
            };
        }

        return { style };
    }

    // Clear discount code error when user removes the discount code
    handleDiscountCodeInputChange = (event, newValue, previousValue, name) => {
        // Always update the redux-form value
        if (this.props.change) {
            this.props.change("checkout", "discountCode", newValue || "");
        }
        // Clear error if value is empty
        if (!newValue) {
            // if (this.props.touch) {
            //     this.props.touch("discountCode");
            // }
            setTimeout(() => {
                this.recalculateOrder();
            }, 0);
        }

    };

    render() {
        const { t, settings, checkoutSale } = this.props;
        const confirmResult = this.handleCheckoutConfirmationsAndAlerts();
        if (confirmResult.shouldReturn === true) {
            return confirmResult.returnResult;
        }

        const saleTotal = checkoutSale
            ? checkoutSale.saleTotalAfterDiscount
            : 0;

        const { activeStep } = this.state;
        const { shipping, payment } = this.props;

        const backButton = this.getBackButton();

        const nextButton = this.getNextButton();

        const addressStep = this.getAddressStep();
        const paymentStep = settings.isStripeElementsFeatureEnabled ? this.getStripeElementsPaymentStep() : this.getpaymentStep();

        return (
            <Fragment>
                {confirmResult.overlayConfirmResult}
                <form
                    method="post"
                    onSubmit={this.props.handleSubmit(
                        this.handleSubmitOrder.bind(this)
                    )}
                >
                    <div className="row">
                        <div className="col-xl-9 col-lg-8">
                            {!settings.isAppMode && <div className="checkout-steps">
                                <a
                                    href={null}
                                    role="button"
                                    className={
                                        activeStep ===
                                            CheckoutWizardSteps.Review
                                            ? "active"
                                            : ""
                                    }
                                    onClick={() =>
                                        this.handleWizardTabClick(
                                            CheckoutWizardSteps.Review
                                        )
                                    }
                                >
                                    3. <span className="ellipsis" title={t("Review")}>{t("Review")}{" "}</span>
                                </a>
                                <a
                                    href={null}
                                    role="button"
                                    className={
                                        activeStep ===
                                            CheckoutWizardSteps.Payment
                                            ? "active"
                                            : activeStep >
                                                CheckoutWizardSteps.Payment
                                                ? "completed"
                                                : ""
                                    }
                                    onClick={() =>
                                        this.handleWizardTabClick(
                                            CheckoutWizardSteps.Payment
                                        )
                                    }
                                >
                                    <span className="angle" />
                                    2. <span className="ellipsis" title={t("Payment")}>{t("Payment")}</span>
                                </a>
                                <a
                                    href={null}
                                    role="button"
                                    className={
                                        activeStep ===
                                            CheckoutWizardSteps.ShippingAddress
                                            ? "active"
                                            : activeStep >
                                                CheckoutWizardSteps.ShippingAddress
                                                ? "completed"
                                                : ""
                                    }
                                    onClick={() =>
                                        this.handleWizardTabClick(
                                            CheckoutWizardSteps.ShippingAddress
                                        )
                                    }
                                >
                                    <span className="angle" />
                                    1. <span className="ellipsis" title={t("Address")}>{t("Address")}</span>
                                </a>
                            </div>}
                            {/* <!-- Checkout Adress--> */}
                            {addressStep}

                            {/* <!-- Payment --> */}
                            {paymentStep}

                            <div
                                className={`col-xl-12 col-lg-12 transition-item ${activeStep === CheckoutWizardSteps.Review
                                        ? "fade-in"
                                        : "fade-out"
                                    }`}
                            >
                                <Cart isReadOnly={true} showTotals={false} />
                            </div>
                            {settings.showTermsOnCheckout === true && activeStep === CheckoutWizardSteps.Review && (
                                <div className="checkout-terms-row">
                                    <p>
                                        <input
                                            type="checkbox"
                                            className="mr-2 chk-lg"
                                            onChange={this.handleAgreeToTerms.bind(this)}
                                            id="chkAgreeTerms"
                                        />
                                        <label htmlFor="chkAgreeTerms" style={{ marginBottom: "0px" }}>
                                            {" "}{t("I have read the")}
                                        </label>
                                        <a
                                            target="_blank"
                                            href={t("TermsConditionsUrl")}
                                            className="pl-1 pr-1"
                                        >
                                            {t("terms and conditions")}
                                        </a>
                                        <label htmlFor="chkAgreeTerms" style={{ marginBottom: "0px" }}>
                                            {" "}{t("and accept them")}
                                        </label>
                                    </p>
                                </div>
                            )}
                            <div className="checkout-footer">
                                <div className="column">{backButton}</div>
                                <div className="column">{nextButton}</div>
                            </div>
                        </div>
                        {/* <!-- Sidebar          --> */}
                        <div className="col-xl-3 col-lg-4">
                            <aside className="sidebar">
                                <div className="padding-top-2x hidden-lg-up" />
                                {/* <!-- Order Summary Widget--> */}
                                {/*<CartTotals cart={cart} settings={settings} showTitle={true} />*/}
                                <OrderSummary showTitle={true} />
                                {activeStep > CheckoutWizardSteps.Payment ? (
                                    <PaymentInfo
                                        amount={saleTotal}
                                        payment={payment}
                                        isKlarna={this.state.paymentMethod === PaymentMethodEnum.Klarna}
                                        isOpenPay={this.state.paymentMethod === PaymentMethodEnum.OpenPay}
                                        isInvoice={this.state.paymentMethod === PaymentMethodEnum.BankTransfer}
                                        isMobilePay={this.state.paymentMethod === PaymentMethodEnum.MobilePay}
                                    />
                                ) : null}
                                {activeStep >
                                    CheckoutWizardSteps.ShippingAddress ? (
                                    <ShippingInfo
                                        settings={settings}
                                        shipping={shipping}
                                    />
                                ) : null}
                            </aside>
                        </div>
                    </div>
                </form>
            </Fragment>
        );
    }

    getAddressStep() {
        const { t, user, settings } = this.props;

        const { activeStep, disableAddressFields } = this.state;
        const { shipping } = this.props;
        const selectedRegion = settings.deliveryRegions.find(
            (r) => r.id === parseInt(shipping.regionId)
        );
        shipping.regionName = selectedRegion ? selectedRegion.name : "";
        if (user.isNativeCustomer === true) {
            shipping.regionName = user.regionName;
        }

        const regionSelection = this.getRegionSelect();
        return (
            <div
                className={`col-xl-12 col-lg-12 transition-item ${activeStep === CheckoutWizardSteps.ShippingAddress
                        ? "fade-in"
                        : "fade-out"
                    }`}
            >
                <h4>{t("Shipping Address")}</h4>
                <hr className="padding-bottom-1x" />
                <div className="row"></div>
                <div className="row">
                    <div className="col-sm-2">
                        <div className="form-group">
                            <label htmlFor="titleId">{t("Title")}</label>
                            <Field
                                name="titleId"
                                component={FormField}
                                // validate={[required({ msg: t("is required") })]}
                                className="form-control"
                            >
                                <option value="">{t("Select a title")}</option>
                                {settings.titles &&
                                    settings.titles.map((option) => (
                                        <option
                                            value={option.id}
                                            key={option.id}
                                        >
                                            {option.name}
                                        </option>
                                    ))}
                            </Field>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label htmlFor="firstName">{t("First Name")}</label>
                            <Field
                                className="form-control"
                                type="text"
                                name="firstName"
                                icon="icon-head"
                                component={FormField}
                                placeholder={t("First Name")}
                                validate={[required({ msg: t("is required") })]}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="lastName">{t("Surname")}</label>
                            <Field
                                className="form-control"
                                type="text"
                                name="lastName"
                                icon="icon-head"
                                component={FormField}
                                placeholder={t("Surname")}
                                validate={[required({ msg: t("is required") })]}
                            />
                        </div>
                    </div>
                </div>
                <div className="row padding-bottom-1x">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="region">{t("Region")}</label>
                            {regionSelection}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="organization">
                                {t("Organization")}
                            </label>
                            <Field
                                className="form-control"
                                type="text"
                                name="organization"
                                component={FormField}
                                placeholder={t("Organization")}
                            />
                        </div>
                    </div>
                </div>
                {settings.useAddressAutoCompleteInVipShop &&
                    settings.googleKey && (
                        <GoogleAddressAutoComplete
                            settings={settings}
                            onChange={this.onGoogleAddressChange.bind(this)}
                        />
                    )}
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor="address1">{t("Address 1")}</label>
                            <Field
                                className="form-control"
                                type="text"
                                name="address1"
                                component={FormField}
                                placeholder={t("Address 1")}
                                validate={[required({ msg: t("is required") })]}
                                disabled={disableAddressFields}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6 atw-hide no-hide se-hide fi-hide">
                        <div className="form-group">
                            <label htmlFor="address2">{t("Address 2")}</label>
                            <Field
                                className="form-control"
                                type="text"
                                name="address2"
                                component={FormField}
                                placeholder={t("Address 2")}
                                disabled={disableAddressFields}
                            />
                        </div>
                    </div>

                    <div className="col-sm-6 atw-hide no-hide se-hide fi-hide">
                        <div className="form-group">
                            <label htmlFor="address3">{t("Address 3")}</label>
                            <Field
                                className="form-control"
                                type="text"
                                name="address3"
                                component={FormField}
                                // removed as some countries don't require address3 even when using auto complete
                                // validate={ settings.useAddressAutoCompleteInVipShop ? [required({ msg: t("is required") })] : [] }
                                placeholder={t("Address 3")}
                                disabled={disableAddressFields}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-3 col-lg-2">
                        <div className="form-group">
                            <label htmlFor="postCode">{t("Post Code")}</label>
                            <Field
                                className="form-control"
                                type="text"
                                name="postCode"
                                component={FormField}
                                placeholder={t("Post Code")}
                                validate={[required({ msg: t("is required") })]}
                                disabled={disableAddressFields}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-3 col-lg-4">
                        <div className="form-group">
                            <label htmlFor="address4">{t("City/County")}</label>
                            <Field
                                className="form-control"
                                type="text"
                                name="address4"
                                icon="icon-globe"
                                component={FormField}
                                placeholder={t("City/County")}
                                validate={[required({ msg: t("is required") })]}
                                disabled={disableAddressFields}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getStripeElementsPaymentStep() {
        const { t, settings, checkoutSale } = this.props;

        const saleTotal = checkoutSale ? checkoutSale.saleTotalAfterDiscount : 0;
        const belowOpenpayLimit = saleTotal < settings.openpayMinLimit;
        const aboveOpenpayLimit = saleTotal > settings.openpayMaxLimit;
        const isOpenpayEligible = settings.isOpenpayEnabled === true && belowOpenpayLimit === false && aboveOpenpayLimit === false;

        const belowKlarnaLimit = saleTotal < settings.klarnaMinLimit;
        const aboveKlarnaLimit = saleTotal > settings.klarnaMaxLimit;
        const isKlarnaEligible = settings.isKlarnaEnabled === true && belowKlarnaLimit === false && aboveKlarnaLimit === false;

        const { activeStep, paymentMethod } = this.state;

        const shouldValidateCard = paymentMethod === PaymentMethodEnum.Card;

        const { payment } = this.props;


        return (
            <div className={`col-xl-12 col-lg-12 transition-item ${activeStep === CheckoutWizardSteps.Payment ? "fade-in" : "fade-out"}`}  >

                <h4>{t("Choose Payment Method")}</h4>

                <hr className="padding-bottom-1x" />
                <div className="card mb-2">
                    <div className="card-header"><i className="icon-columns d-inline mr-2"></i><h6 className="d-inline">{t("I Have A Discount Code")}</h6>
                        {this.state.isDiscountCodeApplied &&
                            <span className="text-sm text-success text-bold float-right">
                                {t("Discount Code Applied")}  <FontAwesomeIcon icon={faCircleCheck} />
                            </span>}
                    </div>
                    <div className="card-body">
                        {!this.state.isDiscountCodeApplied && <div className="flex-row d-flex">
                            <div className="col-9 ">
                                <Field
                                    className="form-control text-bold"
                                    type="text"
                                    name="discountCode"
                                    component={FormField}
                                    placeholder={t("Discount Code")}
                                    format={(value, name) => value ? value.toUpperCase() : value}
                                    onChange={this.handleDiscountCodeInputChange}
                                />
                            </div>
                            <a href={null} role="button" className="btn btn-primary btn-sm float-right col-3" onClick={this.handleApplyDiscountCode} style={{display:"inline-flex",alignItems:"center",minWidth:0,gap:"0.35rem"}}>
                                <span className="ellipsis" title={t("Apply Discount Code")}style={{minWidth:0,flex:"1 1 auto"}}>{t("Apply Discount Code")}</span>
                            </a>
                        </div>}
                        {(this.state.isDiscountCodeApplied || this.props.discountCode) &&
                            <div className="row d-flex mx-2">
                                <div className="input-group form-group mg-2">
                                    <span className="input-group-btn">
                                        <button type="button" onClick={this.handleRemoveDiscountCode.bind(this)} title={t("Remove Discount Code")} >
                                            <FontAwesomeIcon className="red" icon={faCircleXmark} />
                                        </button>
                                    </span>
                                    <input
                                        className="form-control text-bold"
                                        type="text"
                                        name="discountCode"
                                        placeholder={t("Discount Code")}
                                        disabled
                                        value={this.props.discountCode}
                                    />

                                </div>
                            </div>}

                    </div>
                </div>

                <div className="d-flex flex-wrap mb-2">
                    <div className="col mb-3 mb-sm-0 p-0">
                        <a className="payment-button" onClick={() => this.handlePaymentClick(PaymentMethodEnum.Card)}>
                            <div className={`card payment-card ${paymentMethod === PaymentMethodEnum.Card ? 'payment-selected-border' : ''}`}>
                                <div className="card-body d-flex align-items-center">
                                    <img src="img/card.svg" className="payment-img" alt="Card Image" />
                                    <label className="form-check-label ms-2" htmlFor="cardOption">
                                        Card
                                    </label>
                                </div>
                            </div>
                        </a>

                    </div>
                    {settings.isMobilePayEnabled && (<div className="col mb-3 mb-sm-0">
                        <a className="payment-button" onClick={() => this.handlePaymentClick(PaymentMethodEnum.MobilePay)}>
                            <div className={`card payment-card ${paymentMethod === PaymentMethodEnum.MobilePay ? 'payment-selected-border' : ''}`}>
                                <div className="card-body d-flex align-items-center">
                                    <img src="img/MobilePay/VippsMobilePay_Logo_Primary_RGB_Black.svg" className="payment-img" alt="MobilePay Image" />
                                    {/*<label className="form-check-label ms-2">{t("Pay with MobilePay")}</label>*/}
                                </div>
                            </div>
                        </a>

                    </div>)}
                    {settings.isInvoiceEnabled && (<div className="col mb-3 mb-sm-0">
                        <a className="payment-button" onClick={() => this.handlePaymentClick(PaymentMethodEnum.BankTransfer)}>
                            <div className={`card payment-card ${paymentMethod === PaymentMethodEnum.BankTransfer ? 'payment-selected-border' : ''}`}>
                                <div className="card-body d-flex align-items-center">
                                    <FontAwesomeIcon icon={faFileInvoice} className="payment-img" />
                                    <label className="form-check-label ms-2">{t('Pay With Invoice')}</label>
                                </div>
                            </div>
                        </a>

                    </div>)}

                    {settings.isKlarnaEnabled && (<div className="col mb-3 mb-sm-0">
                        <a className="payment-button" onClick={() => this.handlePaymentClick(PaymentMethodEnum.Klarna)}>
                            <div className={`card payment-card ${paymentMethod === PaymentMethodEnum.Klarna ? 'payment-selected-border' : ''}`}>
                                <div className="card-body d-flex align-items-center">
                                    <img className="payment-img" src="img/Klarna/Klarna-logo-black.svg" alt="Klarna Image" />

                                </div>
                            </div>
                        </a>

                    </div>)}

                    {settings.isOpenpayEnabled && (<div className="col mb-3 mb-sm-0">
                        <a className="payment-button" onClick={() => this.handlePaymentClick(PaymentMethodEnum.OpenPay)}>
                            <div className={`card payment-card ${paymentMethod === PaymentMethodEnum.OpenPay ? 'payment-selected-border' : ''}`}>
                                <div className="card-body d-flex align-items-center">
                                    <p className="payment-img">{t("Pay With Open Pay")}</p>

                                </div>
                            </div>
                        </a>

                    </div>)}


                </div>

                <div className="accordion" id="accordion" role="tablist">
                    {this.state.paymentMethod === PaymentMethodEnum.Card && <div className="card">
                        <div className="card-header" role="tab">
                            <h6>
                                <div
                                    className="accordion-toggle"
                                    style={{ cursor: 'pointer' }}
                                    //   href="#card"
                                    //   data-toggle="collapse"
                                    onClick={this.payByCardHanlder.bind(this)}
                                >
                                    <i className="icon-columns" style={{ marginTop: '-4px', marginRight: '7px' }} />{t("Pay with Credit Card")}
                                </div>
                            </h6>
                        </div>
                        <div className={`collapse ${this.state.paymentMethod === PaymentMethodEnum.Card ? 'show' : ''}`}
                            // className="collapse show"
                            id="card"
                            role="tabpanel"
                        // data-parent="#accordion"
                        >
                            <div className="card-body">
                                <p>
                                    {t("We accept following cards")}:&nbsp;<img
                                        className="d-inline-block align-middle credit-cards-list"
                                        src="img/credit-cards.png"
                                        alt={t("Cerdit Cards")}
                                    />
                                    <span className="text-danger col-sm-4">{this.state.cardElementGeneralError}</span>
                                </p>
                                <div className="row" >
                                    <div className="form-group col-sm-6" style={{ paddingTop: '10px', marginBottom: '0px !important', fontFamily: 'Maven Pro, Helvetica, Arial, sans-serif' }}>
                                        <CardNumberElement className="form-control"
                                            options={this.getStripeElementOptions(true)}
                                            onChange={e => this.handleCardElementsValidation(e, "cardNumber")}
                                        ></CardNumberElement>
                                        <span className="text-danger col-sm-4">{this.state.cardElementValidation.cardNumberError}</span>
                                    </div>
                                    <div className="form-group col-sm-6" style={{ paddingTop: '10px', marginBottom: '0px !important' }}>
                                        <Field
                                            className="form-control"
                                            type="text"
                                            name="name"
                                            component={FormField}
                                            placeholder={t("Full Name")}
                                            validate={shouldValidateCard ? [required({ msg: t("is required"), }),] : []}
                                            onFocus={this.handleInputFocus}
                                        />
                                    </div>
                                    <div className="form-group col-sm-3" style={{ paddingTop: '10px', marginBottom: '0px !important', fontFamily: 'Maven Pro, Helvetica, Arial, sans-serif' }}>
                                        <CardExpiryElement className="form-control"
                                            onChange={e => this.handleCardElementsValidation(e, "cardExpiry")}
                                            options={this.getStripeElementOptions()}
                                        ></CardExpiryElement>
                                        <span className="text-danger col-sm-4">{this.state.cardElementValidation.cardExpiryError}</span>
                                    </div>
                                    <div className="form-group col-sm-3" style={{ paddingTop: '10px', marginBottom: '0px !important', fontFamily: 'Maven Pro, Helvetica, Arial, sans-serif' }}>
                                        <CardCvcElement className="form-control"
                                            options={this.getStripeElementOptions()}
                                            onChange={e => this.handleCardElementsValidation(e, "cardCVC")}
                                        ></CardCvcElement>
                                        <span className="text-danger col-sm-4">{this.state.cardElementValidation.cardCVCError}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}

                    {(this.state.paymentMethod === PaymentMethodEnum.MobilePay) && settings.isMobilePayEnabled && (
                        <div className="card">
                            <div className="card-header" role="tab">
                                <h6>
                                    <a href="#mobilepay" data-toggle="collapse">
                                        {this.state.paymentMethod === PaymentMethodEnum.MobilePay && (
                                            <div
                                                onClick={this.payByMobilePayHanlder.bind(
                                                    this
                                                )}>
                                                <img className="payment-img" src="img/MobilePay/VippsMobilePay_Logo_Primary_RGB_Black.svg" alt="Mobile Pay logo" />
                                                {/*{t("Pay with MobilePay")}*/}
                                            </div>
                                        )}
                                    </a>
                                </h6>
                            </div>

                            <div className="collapse show" id="mobilepay" role="tabpanel" data-parent="#accordion">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-6 col-md-3 col-lg-4">
                                            <div className="form-group">
                                                <p>
                                                    <input
                                                        type="checkbox"
                                                        className="mr-2"
                                                        readOnly
                                                        checked={this.state.paymentMethod === PaymentMethodEnum.MobilePay}

                                                    />
                                                    {t("Pay with MobilePay")}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* invoice */}
                    {(settings.isInvoiceEnabled && this.state.paymentMethod === PaymentMethodEnum.BankTransfer) &&
                        <div className="card">
                            <div className="card-header" role="tab">
                                <h6>
                                    <div className="accordion-toggle"
                                        onClick={this.payByInvoiceHandler.bind(this)}
                                        style={{ cursor: 'pointer' }}
                                    //     href="#invoice"

                                    //  data-toggle="collapse"
                                    >
                                        <i className="icon-columns" style={{ marginTop: '-4px', marginRight: '7px' }} />
                                        {t("Pay with Invoice")}
                                    </div>
                                </h6>
                            </div>
                            <div className={`collapse ${this.state.paymentMethod === PaymentMethodEnum.BankTransfer ? 'show' : ''}`}
                                //  className="collapse"
                                id="invoice"
                                role="tabpanel"
                            // data-parent="#accordion"
                            >
                                <div className="card-body">
                                    <p>
                                        <input
                                            type="checkbox"
                                            className="mr-2"
                                            readOnly
                                            checked={this.state.paymentMethod === PaymentMethodEnum.BankTransfer}

                                        />
                                        {t("Use Invoice")}
                                    </p>
                                </div>
                            </div>
                        </div>
                    }

                    {/* end of Invoice */}
                    {(settings.isKlarnaEnabled && this.state.paymentMethod === PaymentMethodEnum.Klarna) && (
                        <div className="card">
                            <div className="card-header" role="tab">
                                {isKlarnaEligible && (
                                    <h6>
                                        <div
                                            className="accordion-toggle"
                                            style={{ cursor: 'pointer' }}
                                            //  href="#klarna"
                                            // data-toggle="collapse"
                                            onClick={this.payByKlarnaHanlder.bind(
                                                this
                                            )}
                                        >
                                            <img src="img/Klarna/Klarna-logo.svg" />{" "}
                                            {t(
                                                "Shop now. Pay over time with Klarna"
                                            )}
                                        </div>
                                    </h6>
                                )}
                                {belowKlarnaLimit && (
                                    <h6>
                                        <a
                                            href="#klarna"
                                            // data-toggle="collapse"
                                            className={`collapse ${this.state.paymentMethod === PaymentMethodEnum.Klarna ? 'show' : ''}`}

                                        >
                                            <img
                                                src="img/Klarna/Klarna-logo-black.svg"
                                                className="black-logo"
                                            />{" "}
                                            {t(
                                                "Your sale is below the minimum amount to be eligible to pay with Klarna"
                                            )}
                                        </a>
                                    </h6>
                                )}

                                {aboveKlarnaLimit && (
                                    <h6>
                                        <a
                                            href="#klarna"
                                            data-toggle="collapse"
                                        >
                                            <img
                                                src="img/Klarna/Klarna-logo-black.svg"
                                                className="black-logo"
                                            />{" "}
                                            {t(
                                                "Your sale is above the maximum amount to be eligible to pay with Klarna"
                                            )}
                                        </a>
                                    </h6>
                                )}
                            </div>
                            {isKlarnaEligible && (
                                <div
                                    className={`collapse ${this.state.paymentMethod === PaymentMethodEnum.Klarna ? 'show' : ''}`}
                                    //className="collapse"
                                    id="klarna"
                                    role="tabpanel"
                                // data-parent="#accordion"
                                >
                                    <div className="card-body">
                                        <p>
                                            <input
                                                type="checkbox"
                                                className="mr-2"
                                                readOnly
                                                checked={this.state.paymentMethod === PaymentMethodEnum.Klarna}
                                            />
                                            {t(
                                                "Klarna's Pay in 3 instalments and Pay in 30 days credit agreements are not regulated by the FCA. Use of these and any missed payments may affect your ability to obtain credit from Klarna and other lenders. 18+, UK residents only. Subject to status. T&Cs apply."
                                            )}
                                            <a
                                                target="_blank"
                                                href="http://klarna.com/uk/terms-and-condition"
                                            >
                                                klarna.com/uk/terms-and-conditions
                                            </a>
                                        </p>
                                        <div className="row">
                                            <div className="col-sm-6 col-md-3 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="email">
                                                        {t("Email")}
                                                    </label>
                                                    <Field
                                                        className="form-control"
                                                        type="text"
                                                        name="email"
                                                        icon="icon-email"
                                                        component={FormField}
                                                        placeholder={t("Email")}
                                                        validate={
                                                            paymentMethod === PaymentMethodEnum.Klarna
                                                                ? [
                                                                    required({
                                                                        msg: t(
                                                                            "is required"
                                                                        ),
                                                                    }),
                                                                ]
                                                                : []
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {(settings.isOpenpayEnabled && this.state.paymentMethod === PaymentMethodEnum.OpenPay) && (
                        <div className="card">
                            <div className="card-header" role="tab">
                                {isOpenpayEligible && (
                                    <h6>
                                        <a
                                            href="#openPay"
                                            data-toggle="collapse"
                                            onClick={this.payByOpenpayHanlder.bind(
                                                this
                                            )}
                                        >
                                            <opy-cart
                                                amount={saleTotal}
                                                logo="grey-on-amberbg"
                                                more-info-text={t("More info")}
                                                logo-position="right"
                                            ></opy-cart>
                                            {/*<img src="img/Openpay-Amber-BG.png" /> {t("Buy now. Pay smarter")}*/}
                                        </a>
                                    </h6>
                                )}
                                {belowOpenpayLimit && (
                                    <h6>
                                        <a
                                            href="#openPay"
                                            data-toggle="collapse"
                                        >
                                            <opy-cart
                                                amount={saleTotal}
                                                logo="grey"
                                                more-info-text={t("More info")}
                                            ></opy-cart>
                                        </a>
                                    </h6>
                                )}

                                {aboveOpenpayLimit && (
                                    <h6>
                                        <a
                                            href="#openPay"
                                            data-toggle="collapse"
                                        >
                                            <opy-cart
                                                amount={saleTotal}
                                                logo="grey"
                                            ></opy-cart>
                                        </a>
                                    </h6>
                                )}
                            </div>
                            {isOpenpayEligible && (
                                <div
                                    className="collapse"
                                    id="openPay"
                                    role="tabpanel"
                                    data-parent="#accordion"
                                >
                                    <div className="card-body">
                                        <input
                                            type="checkbox"
                                            className="mr-2"
                                            readOnly
                                            checked={this.state.paymentMethod === PaymentMethodEnum.OpenPay}
                                        />
                                        {/* <opy-cart amount={saleTotalWithoutDecimalPoints} logo="grey-on-amberbg" more-info-text={t("More info")} className="d-inline-block" ></opy-cart>*/}
                                        <div className="d-inline-block">
                                            <opy-cart
                                                amount={saleTotal}
                                                logo="grey-on-amberbg"
                                                more-info-text={t("More info")}
                                            ></opy-cart>
                                        </div>
                                        {/*  <label> {t("Pay over 3-4 interest free monthly instalments.")}</label>*/}
                                        <p>
                                            {t(
                                                "You will be redirected to Openpay's website to complete your order after you review your order and click"
                                            )}{" "}
                                            '{t("Complete Order")}'
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>

            </div>
        );
    }
    handlePaymentClick = (paymentMethod) => {
        this.setState({
            paymentMethod: paymentMethod
        });
    };

    getpaymentStep() {
        const { t, settings, checkoutSale } = this.props;

        const saleTotal = checkoutSale
            ? checkoutSale.saleTotalAfterDiscount
            : 0;
        const belowOpenpayLimit = saleTotal < settings.openpayMinLimit;
        const aboveOpenpayLimit = saleTotal > settings.openpayMaxLimit;
        const isOpenpayEligible =
            settings.isOpenpayEnabled === true &&
            belowOpenpayLimit === false &&
            aboveOpenpayLimit === false;

        const belowKlarnaLimit = saleTotal < settings.klarnaMinLimit;
        const aboveKlarnaLimit = saleTotal > settings.klarnaMaxLimit;
        const isKlarnaEligible =
            settings.isKlarnaEnabled === true &&
            belowKlarnaLimit === false &&
            aboveKlarnaLimit === false;

        const {
            activeStep,
            paymentMethod
        } = this.state;

        const shouldValidateCard =
            paymentMethod === PaymentMethodEnum.Card;

        const { payment } = this.props;

        return (
            <div
                className={`col-xl-12 col-lg-12 transition-item ${activeStep === CheckoutWizardSteps.Payment
                        ? "fade-in"
                        : "fade-out"
                    }`}
            >
                <h4>{t("Choose Payment Method")}</h4>

                <hr className="padding-bottom-1x" />
                {/* discount */}
                <div className="card mb-2">
                    <div className="card-header">
                        <i className="icon-columns d-inline mr-2"></i>
                        <h6 className="d-inline">
                            {t("I Have A Discount Code")}
                        </h6>
                        {this.state.isDiscountCodeApplied && (
                            <span className="text-sm text-success text-bold float-right">
                                {t("Discount Code Applied")}{" "}
                                <FontAwesomeIcon icon={faCircleCheck} />
                            </span>
                        )}
                    </div>
                    <div className="card-body">
                        {!this.state.isDiscountCodeApplied && (
                            <div className="flex-row d-flex">
                                <div className="col-9 ">
                                    <Field
                                        className="form-control text-bold"
                                        type="text"
                                        name="discountCode"
                                        component={FormField}
                                        placeholder={t("Discount Code")}
                                        format={(value, name) =>
                                            value ? value.toUpperCase() : value
                                        }
                                        onChange={this.handleDiscountCodeInputChange}
                                    />
                                </div>
                                <a
                                    href={null}
                                    role="button"
                                    className="btn btn-primary btn-sm float-right col-3"
                                    onClick={this.handleApplyDiscountCode}
                                >
                                    <span className="hidden-xs-down btn-text-overflow">
                                        {t("Apply Discount Code")}&nbsp;
                                    </span>
                                    <i className="icon-arrow-right" />
                                </a>
                            </div>
                        )}
                        {(this.state.isDiscountCodeApplied || this.props.discountCode) && (
                            <div className="row d-flex mx-2">
                                <div className="input-group form-group mg-2">
                                    <span className="input-group-btn">
                                        <button
                                            type="button"
                                            onClick={this.handleRemoveDiscountCode.bind(
                                                this
                                            )}
                                            title={t("Remove Discount Code")}
                                        >
                                            <FontAwesomeIcon
                                                className="red"
                                                icon={faCircleXmark}
                                            />
                                        </button>
                                    </span>
                                    <input
                                        className="form-control text-bold"
                                        type="text"
                                        name="discountCode"
                                        placeholder={t("Discount Code")}
                                        disabled
                                        value={this.props.discountCode}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="d-flex flex-wrap mb-2">
                    <div className="col mb-3 mb-sm-0">
                        <a className="payment-button" onClick={() => this.handlePaymentClick(PaymentMethodEnum.Card)}>
                            <div className={`card payment-card ${paymentMethod === PaymentMethodEnum.Card ? 'payment-selected-border' : ''}`}>
                                <div className="card-body d-flex align-items-center">
                                    <img src="img/card.svg" className="payment-img" alt="Card Image" />
                                    <label className="form-check-label ms-2" htmlFor="cardOption">
                                        Card
                                    </label>
                                </div>
                            </div>
                        </a>

                    </div>
                    {settings.isMobilePayEnabled && (<div className="col mb-3 mb-sm-0">
                        <a className="payment-button" onClick={() => this.handlePaymentClick(PaymentMethodEnum.MobilePay)}>
                            <div className={`card payment-card ${paymentMethod === PaymentMethodEnum.MobilePay ? 'payment-selected-border' : ''}`}>
                                <div className="card-body d-flex align-items-center">
                                    <img src="img/MobilePay/VippsMobilePay_Logo_Primary_RGB_Black.svg" className="payment-img" alt="MobilePay Image" />

                                </div>
                            </div>
                        </a>

                    </div>)}
                    {settings.isInvoiceEnabled && (<div className="col mb-3 mb-sm-0">
                        <a className="payment-button" onClick={() => this.handlePaymentClick(PaymentMethodEnum.BankTransfer)}>
                            <div className={`card payment-card ${paymentMethod === PaymentMethodEnum.BankTransfer ? 'payment-selected-border' : ''}`}>
                                <div className="card-body d-flex align-items-center">
                                    <FontAwesomeIcon icon={faFileInvoice} className="payment-img" />
                                    <label className="form-check-label ms-2">{t('Pay With Invoice')}</label>
                                </div>
                            </div>
                        </a>

                    </div>)}

                    {settings.isKlarnaEnabled && (<div className="col mb-3 mb-sm-0">
                        <a className="payment-button" onClick={() => this.handlePaymentClick(PaymentMethodEnum.Klarna)}>
                            <div className={`card payment-card ${paymentMethod === PaymentMethodEnum.Klarna ? 'payment-selected-border' : ''}`}>
                                <div className="card-body d-flex align-items-center">
                                    <img className="payment-img" src="img/Klarna/Klarna-logo-black.svg" alt="Klarna Image" />

                                </div>
                            </div>
                        </a>

                    </div>)}

                    {settings.isOpenpayEnabled && (<div className="col mb-3 mb-sm-0">
                        <a className="payment-button" onClick={() => this.handlePaymentClick(PaymentMethodEnum.OpenPay)}>
                            <div className={`card payment-card ${paymentMethod === PaymentMethodEnum.OpenPay ? 'payment-selected-border' : ''}`}>
                                <div className="card-body d-flex align-items-center">
                                    <p className="payment-img">{t("Pay With Open Pay")}</p>

                                </div>
                            </div>
                        </a>

                    </div>)}

                </div>


                <div className="accordion" id="accordion" role="tablist">
                    {this.state.paymentMethod === PaymentMethodEnum.Card && <div className="card">
                        <div className="card-header" role="tab">
                            <h6>
                                <div
                                    className="accordion-toggle"
                                    style={{ cursor: 'pointer' }}
                                    //   href="#card"
                                    //   data-toggle="collapse"
                                    onClick={this.payByCardHanlder.bind(this)}
                                >
                                    <i className="icon-columns" style={{ marginTop: '-4px', marginRight: '7px' }} />
                                    {t("Pay with Credit Card")}
                                </div>
                            </h6>
                        </div>
                        <div
                            className={`collapse ${this.state.paymentMethod === PaymentMethodEnum.Card ? 'show' : ''}`}
                            // className="collapse show"
                            id="card"
                            role="tabpanel"
                        // data-parent="#accordion"
                        >
                            <div className="card-body">
                                <p>
                                    {t("We accept following cards")}:&nbsp;
                                    <img
                                        className="d-inline-block align-middle credit-cards-list"
                                        src="img/credit-cards.png"
                                        alt={t("Cerdit Cards")}
                                    />
                                </p>
                                <div className="card-wrapper">
                                    <Cards
                                        cvc={payment.cvc}
                                        expiry={payment.expiry}
                                        number={payment.number}
                                        name={payment.name}
                                        focused={this.state.focused}
                                        callback={this.handleCardChange.bind(
                                            this
                                        )}
                                    />
                                </div>
                                <div className="row">
                                    <div className="form-group col-sm-6">
                                        <Field
                                            className="form-control"
                                            type="tel"
                                            name="number"
                                            ref={(input) => {
                                                this.number = input;
                                            }}
                                            component={FormField}
                                            placeholder={t("Card Number")}
                                            pattern="[\d| ]{16,22}"
                                            validate={
                                                shouldValidateCard
                                                    ? [
                                                        required({
                                                            msg: t(
                                                                "is required"
                                                            ),
                                                        }),
                                                    ]
                                                    : []
                                            }
                                            format={formatCreditCardNumber}
                                            onFocus={this.handleInputFocus}
                                        />
                                    </div>
                                    <div className="form-group col-sm-6">
                                        <Field
                                            className="form-control"
                                            type="text"
                                            name="name"
                                            component={FormField}
                                            placeholder={t("Full Name")}
                                            validate={shouldValidateCard ? [required({ msg: t("is required"), }),] : []}
                                            onFocus={this.handleInputFocus}
                                        />
                                    </div>
                                    <div className="form-group col-sm-3">
                                        <Field
                                            className="form-control"
                                            type="tel"
                                            name="expiry"
                                            component={FormField}
                                            placeholder={t("MM/YY")}
                                            pattern="\d\d/\d\d"
                                            validate={
                                                shouldValidateCard
                                                    ? [
                                                        required({
                                                            msg: t(
                                                                "is required"
                                                            ),
                                                        }),
                                                        cardExpiry,
                                                    ]
                                                    : []
                                            }
                                            format={formatExpirationDate}
                                            onFocus={this.handleInputFocus}
                                        />
                                    </div>
                                    <div className="form-group col-sm-3">
                                        <Field
                                            className="form-control"
                                            type="number"
                                            name="cvc"
                                            component={FormField}
                                            placeholder={t("CVC")}
                                            pattern="\d{3,4}"
                                            format={formatCVC}
                                            validate={
                                                shouldValidateCard
                                                    ? [
                                                        required({
                                                            msg: t(
                                                                "is required"
                                                            ),
                                                        }),
                                                        length({
                                                            msg: {
                                                                min: t(
                                                                    "is too short (min is {count, number} characters)"
                                                                ),
                                                                max: t(
                                                                    "is too long (max is {count, number} characters)"
                                                                ),
                                                            },
                                                            in: [3, 4],
                                                        }),
                                                        numericality({
                                                            int: true,
                                                            msg: t(
                                                                "must be numbers only"
                                                            ),
                                                        }),
                                                    ]
                                                    : []
                                            }
                                            onFocus={this.handleInputFocus}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                    {(this.state.paymentMethod === PaymentMethodEnum.MobilePay) && settings.isMobilePayEnabled && (
                        <div className="card">
                            <div className="card-header" role="tab">
                                <h6>
                                    <a href="#mobilepay" data-toggle="collapse">
                                        {this.state.paymentMethod === PaymentMethodEnum.MobilePay && (
                                            <div
                                                onClick={this.payByMobilePayHanlder.bind(
                                                    this
                                                )}>
                                                <img className="payment-img" src="img/MobilePay/VippsMobilePay_Logo_Primary_RGB_Black.svg" alt="Mobile Pay logo" />
                                                {/*{t("Pay with MobilePay")}*/}
                                            </div>
                                        )}
                                    </a>
                                </h6>
                            </div>

                            <div className="collapse show" id="mobilepay" role="tabpanel" data-parent="#accordion">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-6 col-md-3 col-lg-4">
                                            <div className="form-group">
                                                {/* add mobile pay text here */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}


                    {/* invoice */}
                    {settings.isInvoiceEnabled && (this.state.paymentMethod === PaymentMethodEnum.BankTransfer) &&
                        (<div className="card">
                            <div className="card-header" role="tab">
                                <h6>
                                    <div className="accordion-toggle"
                                        onClick={this.payByInvoiceHandler.bind(this)}
                                        style={{ cursor: 'pointer' }}
                                    //     href="#invoice"

                                    //  data-toggle="collapse"
                                    >
                                        <i className="icon-columns" style={{ marginTop: '-4px', marginRight: '7px' }} />
                                        {t("Pay with Invoice")}
                                    </div>
                                </h6>
                            </div>
                            <div
                                className={`collapse ${this.state.paymentMethod === PaymentMethodEnum.BankTransfer ? 'show' : ''}`}
                                //  className="collapse"
                                id="invoice"
                                role="tabpanel"
                            // data-parent="#accordion"
                            >
                                <div className="card-body">
                                    <p>
                                        <input
                                            type="checkbox"
                                            className="mr-2"
                                            readOnly
                                            checked={this.state.paymentMethod === PaymentMethodEnum.BankTransfer}

                                        />
                                        {t("Use Invoice")}
                                    </p>
                                </div>
                            </div>
                        </div>
                        )}
                    {/* end of Invoice */}

                    {settings.isKlarnaEnabled && (this.state.paymentMethod === PaymentMethodEnum.Klarna) && (
                        <div className="card">
                            <div className="card-header" role="tab">
                                {isKlarnaEligible && (
                                    <h6>
                                        <div
                                            className="accordion-toggle"
                                            style={{ cursor: 'pointer' }}
                                            //  href="#klarna"
                                            //  data-toggle="collapse"
                                            onClick={this.payByKlarnaHanlder.bind(
                                                this
                                            )}
                                        >
                                            <img src="img/Klarna/Klarna-logo.svg" />{" "}
                                            {t(
                                                "Shop now. Pay over time with Klarna"
                                            )}
                                        </div>
                                    </h6>
                                )}
                                {belowKlarnaLimit && (
                                    <h6>
                                        <a
                                            href="#klarna"
                                            //data-toggle="collapse"
                                            className={`collapse ${this.state.paymentMethod === PaymentMethodEnum.Klarna ? 'show' : ''}`}

                                        >
                                            <img
                                                src="img/Klarna/Klarna-logo-black.svg"
                                                className="black-logo"
                                            />{" "}
                                            {t(
                                                "Your sale is below the minimum amount to be eligible to pay with Klarna"
                                            )}
                                        </a>
                                    </h6>
                                )}

                                {aboveKlarnaLimit && (
                                    <h6>
                                        <a
                                            href="#klarna"
                                            data-toggle="collapse"
                                        >
                                            <img
                                                src="img/Klarna/Klarna-logo-black.svg"
                                                className="black-logo"
                                            />{" "}
                                            {t(
                                                "Your sale is above the maximum amount to be eligible to pay with Klarna"
                                            )}
                                        </a>
                                    </h6>
                                )}
                            </div>
                            {isKlarnaEligible && (
                                <div
                                    className={`collapse ${this.state.paymentMethod === PaymentMethodEnum.Klarna ? 'show' : ''}`}
                                    //     className="collapse"
                                    id="klarna"
                                    role="tabpanel"
                                //  data-parent="#accordion"
                                >
                                    <div className="card-body">
                                        <p>
                                            <input
                                                type="checkbox"
                                                className="mr-2"
                                                readOnly
                                                checked={this.state.paymentMethod === PaymentMethodEnum.Klarna}
                                            />
                                            {t(
                                                "Klarna's Pay in 3 instalments and Pay in 30 days credit agreements are not regulated by the FCA. Use of these and any missed payments may affect your ability to obtain credit from Klarna and other lenders. 18+, UK residents only. Subject to status. T&Cs apply."
                                            )}
                                            <a
                                                target="_blank"
                                                href="http://klarna.com/uk/terms-and-condition"
                                            >
                                                klarna.com/uk/terms-and-conditions
                                            </a>
                                        </p>
                                        <div className="row">
                                            <div className="col-sm-6 col-md-3 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="email">
                                                        {t("Email")}
                                                    </label>
                                                    <Field
                                                        className="form-control"
                                                        type="text"
                                                        name="email"
                                                        icon="icon-email"
                                                        component={FormField}
                                                        placeholder={t("Email")}
                                                        validate={
                                                            paymentMethod === PaymentMethodEnum.Klarna
                                                                ? [
                                                                    required({
                                                                        msg: t(
                                                                            "is required"
                                                                        ),
                                                                    }),
                                                                ]
                                                                : []
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {settings.isOpenpayEnabled && (this.state.paymentMethod === PaymentMethodEnum.OpenPay) && (
                        <div className="card">
                            <div className="card-header" role="tab">
                                {isOpenpayEligible && (
                                    <h6>
                                        <a
                                            href="#openPay"
                                            data-toggle="collapse"
                                            onClick={this.payByOpenpayHanlder.bind(
                                                this
                                            )}
                                        >
                                            <opy-cart
                                                amount={saleTotal}
                                                logo="grey-on-amberbg"
                                                more-info-text={t("More info")}
                                                logo-position="right"
                                            ></opy-cart>
                                            {/*<img src="img/Openpay-Amber-BG.png" /> {t("Buy now. Pay smarter")}*/}
                                        </a>
                                    </h6>
                                )}
                                {belowOpenpayLimit && (
                                    <h6>
                                        <a
                                            href="#openPay"
                                            data-toggle="collapse"
                                        >
                                            <opy-cart
                                                amount={saleTotal}
                                                logo="grey"
                                                more-info-text={t("More info")}
                                            ></opy-cart>
                                        </a>
                                    </h6>
                                )}

                                {aboveOpenpayLimit && (
                                    <h6>
                                        <a
                                            href="#openPay"
                                            data-toggle="collapse"
                                        >
                                            <opy-cart
                                                amount={saleTotal}
                                                logo="grey"
                                            ></opy-cart>
                                        </a>
                                    </h6>
                                )}
                            </div>
                            {isOpenpayEligible && (
                                <div
                                    className="collapse"
                                    id="openPay"
                                    role="tabpanel"
                                    data-parent="#accordion"
                                >
                                    <div className="card-body">
                                        <input
                                            type="checkbox"
                                            className="mr-2"
                                            readOnly
                                            checked={this.state.paymentMethod === PaymentMethodEnum.OpenPay}
                                        />
                                        {/* <opy-cart amount={saleTotalWithoutDecimalPoints} logo="grey-on-amberbg" more-info-text={t("More info")} className="d-inline-block" ></opy-cart>*/}
                                        <div className="d-inline-block">
                                            <opy-cart
                                                amount={saleTotal}
                                                logo="grey-on-amberbg"
                                                more-info-text={t("More info")}
                                            ></opy-cart>
                                        </div>
                                        {/*  <label> {t("Pay over 3-4 interest free monthly instalments.")}</label>*/}
                                        <p>
                                            {t(
                                                "You will be redirected to Openpay's website to complete your order after you review your order and click"
                                            )}{" "}
                                            '{t("Complete Order")}'
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

function validate(values, props) {
    const errors = {};
    //const { t } = props;
    //if (utils.validations.isValidLuhn(values.number) === false) {
    //    errors.number = t("Invalid card number");
    //}

    return errors;
}

function mapStateToProps(state) {
    const selector = formValueSelector("checkout");
    const { user, cart, settings, checkoutSale, orderResponse } = state;

    const shipping = selector(
        state,
        "titleId",
        "firstName",
        "lastName",
        "organization",
        "postCode",
        "address1",
        "address2",
        "address3",
        "address4",
        "regionId"
    );
    let payment = selector(
        state,
        "focused",
        "name",
        "number",
        "name",
        "validFrom",
        "issueNumber",
        "cvc",
        "expiry",
        "email"
    );

    if (Object.keys(payment).length === 0 && payment.constructor === Object) {
        payment = {
            number: "",
            name: `${user.firstName} ${user.lastName}`,
            validFrom: "",
            issueNumber: "",
            cvc: "",
            expiry: "",
            email: user.email,
        };
    }

    let discountCode = selector(state, "discountCode");
    const errors = getFormSyncErrors("checkout")(state); // Bind Sync errors to "this.props.errors"

    return {
        user,
        cart,
        settings,
        checkoutSale,
        orderResponse,
        shipping,
        payment,
        discountCode,
        errors,
        orderSubmitError: state.error,
        initialValues: { ...state.user, ...payment },
    };
}

function asyncValidate(values, dispatch, props) {
    const { t, checkoutSale } = props;
    if (
        checkoutSale &&
        checkoutSale.validationResult &&
        checkoutSale.validationResult.hasError == true
    ) {
        return Promise.reject({
            discountCode: t(checkoutSale.validationResult.errorText) + (checkoutSale.validationResult.errorTextExtra != null ? checkoutSale.validationResult.errorTextExtra : ""),
        });
    }
    return Promise.resolve();
}

CheckoutForm = connect(
    mapStateToProps,
    {
        checkout,
        checkSession,
        buildCheckoutSale,
        storeCheckoutSale,
        clearOrder,
        cancelExternalRedirect,
        createOpenpayOrder,
        change,
        createStripeCardToken,
    },
    null,
    { forwardRef: true }
)(CheckoutForm);

CheckoutForm = withRouter(
    reduxForm({
        form: "checkout",
        validate,
        asyncValidate,
        asyncBlurFields: ["discountCode"],
    })(CheckoutForm)
);

// The following duplicate line is a workaround to allow the binding the form initial values from stats as the order of connect and router has a conflict. if we bind to static data we don't need this line
// need more investigation to figure if it is from our side
CheckoutForm = connect(mapStateToProps, {
    checkout,
    checkSession,
    buildCheckoutSale,
    storeCheckoutSale,
    clearOrder,
    cancelExternalRedirect,
    createOpenpayOrder,
    resetOpenpayPlan,
    change,
    createStripeCardToken,
})(CheckoutForm);
export default withTranslation()(CheckoutForm);
